// utils/reportDownloader.js
import api from '../api';

export const downloadEngagements = async (params) => {
  try {
    const response = await api.get('/reports/export', {
      params,
      timeout: 300000 //5mins
    });

    // The endpoint now returns JSON with message, reportId, and status
    return response.data;
  } catch (error) {
    console.error('Failed to start report generation:', error);
    throw error;
  }
};

export const downloadUsers = async (params, filename = 'report.csv') => {
  try {
    const response = await api.get('/reports/export/users', {
      params,
      responseType: 'blob',
      timeout: 300000 //5mins
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Failed to download report:', error);
  }
};

export const downloadStores = async (params, filename = 'report.csv') => {
  try {
    const response = await api.get('/reports/export/dynamic-stores', {
      params,
      responseType: 'blob',
      timeout: 300000 //5mins
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Failed to download report:', error);
  }
};



export const downloadActivities = async (params, filename = 'report.csv') => {
  try {
    const response = await api.get('/reports/export/activities', {
      params,
      responseType: 'blob',
      timeout: 300000 //5mins
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Failed to download report:', error);
  }
};

export const listReports = async ({ page = 1, limit = 10 } = {}) => {
  try {
    const res = await api.get('/reports', { params: { page, limit } });
    return res.data;
  } catch (error) {
    console.error('Error listing reports:', error);
    return { reports: [], pagination: { total: 0, page: 1, limit, pages: 0 } };
  }
};

export const downloadReportFile = async (key, filename = 'report.csv') => {
  try {
    // If key is a full URL, download directly using browser download (bypasses CORS)
    if (key.startsWith('http')) {
      const link = document.createElement('a');
      link.href = key;
      link.setAttribute('download', filename);
      link.setAttribute('target', '_blank'); // Open in new tab if download doesn't work
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      return;
    }

    // Otherwise use the API endpoint
    const response = await api.get(`/reports/download/${key}`, {
      responseType: 'blob',
      timeout: 900000 //15mins - longer timeout for file downloads
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Failed to download report file:', error);
    throw error;
  }
};

export const deleteReport = async (reportId) => {
  try {
    const response = await api.delete(`/reports/${reportId}`);
    return response.data;
  } catch (error) {
    console.error('Failed to delete report:', error);
    throw error;
  }
};

export const cancelReport = async (reportId) => {
  try {
    const response = await api.post(`/reports/${reportId}/cancel`);
    return response.data;
  } catch (error) {
    console.error('Failed to cancel report:', error);
    throw error;
  }
};
